import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Thongkedangkiemvien from "components/Thongke/Dangkiem/Thongkedangkiemvien.js";
import Thongkephuongtientheothang from "components/Thongke/Dangkiem/Dangkiemthongkephuongtien.js";
export default function Tkdangkiem() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Thống kê đăng kiểm viên",
            tabContent: <Thongkedangkiemvien />,
          },
          {
            tabName: "Thống kê phương tiện theo tháng",
            tabContent: <Thongkephuongtientheothang />,
          },
        ]}
      />
    </div>
  );
}
